import React from 'react'
import Text from '../components/Text.js'

import { colors } from '../constants/theme'

export default props => (
  <Text
    tag='div'
    type='navigation'
    {...props}
    hoverColor={colors.highlight}
    noSelect
    style={{ marginTop: 2, cursor: 'pointer', ...(props.style || {}) }}
    size={14}
    height={14} />
)



// WEBPACK FOOTER //
// ../styleguide/Navigation.js